import { defineMessages } from 'react-intl'

const tourRoomTypeMessages = defineMessages({
  single: {
    id: 'Fk5SDJb6KOcbRV9Gx1fS',
    defaultMessage: 'Single room',
  },
  twin: {
    id: 'GMxrYrOHrGYbPC5hXBA9',
    defaultMessage: 'Twin share room',
  },
  twinShare: {
    id: '4jksZZ-q1G18tEzqvlk7',
    defaultMessage: 'Twin share',
  },
  triple: {
    id: '70Hv6JjDgpL9N7laZrD8',
    defaultMessage: 'Triple room',
  },
  tripleShare: {
    id: 'GcRzpmc0j1YHfYydpwRj',
    defaultMessage: 'Triple share',
  },
  quad: {
    id: 'LGJ_qo_toVelUaFtWljh',
    defaultMessage: 'Quad room',
  },
  quadShare: {
    id: 'PK2tAcBW_awxHaKO_hdr',
    defaultMessage: 'Quad share',
  },
  multiShare: {
    id: 'SnoKGCCq59t-_DRM7y4B',
    defaultMessage: 'Multi share',
  },
})

export default tourRoomTypeMessages
